import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const creditActionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.creditActions,
    queryFn: API.credit.getCreditActions,
  });
